import React from "react";

export default function PageIntro({
  eyebrow,
  title,
  description,
  badges = [],
  actions,
  children,
  className = "",
}) {
  return (
    <section className={`mx-auto max-w-6xl px-4 sm:px-6 ${className}`}>
      {eyebrow && (
        <p className="mb-3 text-xs font-bold uppercase tracking-[0.18em] text-red-600 sm:text-sm">
          {eyebrow}
        </p>
      )}

      <h1 className="max-w-5xl text-3xl font-bold tracking-tight text-slate-950 sm:text-4xl lg:text-5xl lg:leading-[1.12]">
        {title}
      </h1>

      {description && (
        <div className="mt-5 max-w-3xl text-base leading-7 text-slate-600 sm:text-lg sm:leading-8">
          {description}
        </div>
      )}

      {badges.length > 0 && (
        <div className="mt-6 flex flex-wrap gap-2.5 text-sm text-slate-600">
          {badges.map((badge) => (
            <span
              key={typeof badge === "string" ? badge : String(badge)}
              className="rounded-full border border-slate-200 bg-white px-4 py-2 shadow-sm"
            >
              {badge}
            </span>
          ))}
        </div>
      )}

      {actions && (
        <div className="mt-7 flex flex-col gap-3 sm:flex-row sm:flex-wrap">
          {actions}
        </div>
      )}

      {children}
    </section>
  );
}
